import { render, staticRenderFns } from "./Create-Payment.vue?vue&type=template&id=51fa1903&scoped=true"
import script from "./Create-Payment.vue?vue&type=script&lang=js"
export * from "./Create-Payment.vue?vue&type=script&lang=js"
import style0 from "./Create-Payment.vue?vue&type=style&index=0&id=51fa1903&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fa1903",
  null
  
)

export default component.exports